import { createElement, PropTypes } from 'rlink-react';

export default function HistoryControlPoint ({slidePointTitle, tooltipMessage}) {
  return (
    <div className="node node-history node-promoted node-teaser">
      <div className="timeline-item">
        <h5 className="node-title">{slidePointTitle}</h5>
        <div className="field field-name-field-subtitle field-type-text field-label-hidden field-wrapper">{tooltipMessage}</div>
      </div>
      <div className="field field-name-field-year field-type-datetime field-label-hidden field-wrapper">
        <span className="date-display-single">{slidePointTitle}</span>
      </div>
    </div>
  );
}

HistoryControlPoint.propTypes = {
  slidePointTitle: PropTypes.string,
  tooltipMessage: PropTypes.string,
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/History/HistoryControlPoint.jsx